import { Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';

@Component({
    selector: 'app-children-vaccines-banner',
    templateUrl: './children-vaccines-banner.component.html',
    standalone: false
})
export class ChildrenVaccinesBannerComponent implements OnInit, OnDestroy {
  private readonly slotCompUid1: string =
    'childrenVaccinesSquareBannerPDFComponent';
  private readonly slotCompUid2: string =
    'childrenVaccinesVerticalBannerPDFComponent';
  imgUrl1: string = '';
  imgUrl2: string = '';
  private readonly baseUrl: string = '';
  cmsSub: Subscription;
  cmsSub2: Subscription;

  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly _dataService: DataLayerService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {

    this.cmsSub = this.cmsData
      .getComponentData(this.slotCompUid1)
      .subscribe((res: any) => {
        if (res) {
          this.imgUrl1 = this.baseUrl + res?.document.url;
          let cmsResp = JSON.parse(JSON.stringify(res));
          cmsResp.media = cmsResp?.document;
          if (cmsResp?.media?.url) {
            this._dataService.addtoDataLayer('view_promotion', cmsResp);
          }
        }
      });

    this.cmsSub2 = this.cmsData
      .getComponentData(this.slotCompUid2)
      .subscribe((res: any) => {
        if (res) {
          this.imgUrl2 = this.baseUrl + res?.document.url;
          let cmsResp = JSON.parse(JSON.stringify(res));
          cmsResp.media = cmsResp?.document;
          if (cmsResp?.media?.url) {
            this._dataService.addtoDataLayer('view_promotion', cmsResp);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
    this.cmsSub2?.unsubscribe();
  }
}
